import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/imgs/photo-1581091226825-a6a2a5aee158.avif';
import _imports_1 from '../assets/imgs/photo-1549880338-65ddcdfd017b.avif';
import _imports_2 from '../assets/imgs/photo-1524634126442-357e0eac3c14.jpg';
import _imports_3 from '../assets/imgs/1.jpg';
import _imports_4 from '../assets/imgs/04.jpg';
const _hoisted_1 = {
  class: "page-content"
};
const _hoisted_2 = {
  class: "video-section"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "product-video-wrapper"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "video-loading"
};
const _hoisted_7 = {
  class: "content-section case-section"
};
const _hoisted_8 = {
  class: "container"
};
const _hoisted_9 = {
  class: "case-item"
};
const _hoisted_10 = {
  class: "case-media"
};
const _hoisted_11 = {
  class: "case-video-wrapper"
};
const _hoisted_12 = {
  class: "case-video",
  controls: "",
  preload: "metadata"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "content-section purchase-section"
};
const _hoisted_15 = {
  class: "container"
};
const _hoisted_16 = {
  class: "purchase-content"
};
const _hoisted_17 = {
  class: "purchase-options"
};
const _hoisted_18 = {
  class: "purchase-actions"
};
const _hoisted_19 = {
  class: "action-buttons"
};
const _hoisted_20 = {
  key: 0,
  class: "purchase-toast"
};
import promotionVideo from '@/assets/imgs/promotion.mp4';
import videoSrc from '@/assets/imgs/Video.mp4';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';
import { ref, onMounted, onUnmounted } from 'vue';

// 视频元素引用

export default {
  __name: 'Product',
  setup(__props) {
    const videoPlayer = ref(null);
    const isLoading = ref(true);
    const userHasPaused = ref(false);
    const isVideoEnded = ref(false);

    // 视频交互逻辑
    const onVideoClick = e => {
      if (e.target.tagName === 'VIDEO' && videoPlayer.value) {
        const rect = videoPlayer.value.getBoundingClientRect();
        const clickY = e.clientY - rect.top;
        const videoHeight = rect.height;
        if (clickY > videoHeight * 0.85) return;
        try {
          if (videoPlayer.value.paused) {
            videoPlayer.value.play();
            userHasPaused.value = false;
          } else {
            videoPlayer.value.pause();
            userHasPaused.value = true;
          }
        } catch (e) {
          console.error('播放/暂停失败:', e);
        }
      }
    };
    const onVideoPlay = () => {
      isVideoEnded.value = false;
      userHasPaused.value = false;
    };
    const onVideoPause = () => {
      if (!isVideoEnded.value) {
        userHasPaused.value = true;
      }
    };
    const onVideoEnded = () => {
      isVideoEnded.value = true;
      userHasPaused.value = false;
    };
    const onVideoLoaded = () => {
      isLoading.value = false;
      if (videoPlayer.value) {
        videoPlayer.value.addEventListener('ended', () => {
          videoPlayer.value.pause();
          isVideoEnded.value = true;
        });
      }
    };
    const onVideoError = e => {
      console.error('视频加载错误:', e);
      isLoading.value = false;
    };
    const handleKeydown = e => {
      if (e.key === ' ' && videoPlayer.value && document.activeElement !== videoPlayer.value) {
        e.preventDefault();
        if (videoPlayer.value.paused) {
          videoPlayer.value.play();
          userHasPaused.value = false;
        } else {
          videoPlayer.value.pause();
          userHasPaused.value = true;
        }
      }
    };
    const handleVisibilityChange = () => {
      if (document.hidden && videoPlayer.value) {
        videoPlayer.value.pause();
      }
    };

    // 购买提示
    const showToast = ref(false);
    const showComingSoon = () => {
      showToast.value = true;
      setTimeout(() => {
        showToast.value = false;
      }, 2000);
    };
    const goToJD = () => {
      // 埋点
      window.dataLayer?.push({
        event: 'purchase_click',
        channel: 'jd'
      });
      window.open('https://mall.jd.com/index-139026351.html?from=pc&cid=0', '_blank', 'noopener');
    };
    onMounted(() => {
      window.addEventListener('keydown', handleKeydown);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      if (!videoPlayer.value) {
        console.warn('视频元素未获取到');
        isLoading.value = false;
      } else {
        videoPlayer.value.addEventListener('loadeddata', onVideoLoaded);
        videoPlayer.value.addEventListener('error', onVideoError);
        videoPlayer.value.addEventListener('play', onVideoPlay);
        videoPlayer.value.addEventListener('pause', onVideoPause);
        videoPlayer.value.addEventListener('ended', onVideoEnded);
        const playPromise = videoPlayer.value.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('自动播放被阻止:', error);
          });
        }
        videoPlayer.value.loop = false;
        videoPlayer.value.addEventListener('timeupdate', () => {
          if (userHasPaused.value && !videoPlayer.value.paused) {
            videoPlayer.value.pause();
            userHasPaused.value = true;
          }
        });
      }
    });
    onUnmounted(() => {
      window.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (videoPlayer.value) {
        videoPlayer.value.removeEventListener('loadeddata', onVideoLoaded);
        videoPlayer.value.removeEventListener('error', onVideoError);
        videoPlayer.value.removeEventListener('play', onVideoPlay);
        videoPlayer.value.removeEventListener('pause', onVideoPause);
        videoPlayer.value.removeEventListener('ended', onVideoEnded);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(NavBar), _createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("h2", {
        class: "section-title"
      }, "产品演示", -1)), _cache[3] || (_cache[3] = _createElementVNode("p", {
        class: "section-subtitle"
      }, "60秒看懂深眠科技如何重塑您的睡眠体验", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("video", {
        ref_key: "videoPlayer",
        ref: videoPlayer,
        controls: "",
        autoplay: "",
        muted: "",
        playsinline: "",
        class: "product-video",
        onClick: onVideoClick,
        onLoadedmetadata: onVideoLoaded,
        onError: onVideoError,
        onPlay: onVideoPlay,
        onPause: onVideoPause,
        onEnded: onVideoEnded
      }, [_createElementVNode("source", {
        src: _unref(promotionVideo),
        type: "video/mp4"
      }, null, 8, _hoisted_5), _cache[0] || (_cache[0] = _createTextVNode(" 您的浏览器不支持视频播放 "))], 544), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "video-decoration"
      }, null, -1)), isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, "视频加载中...")) : _createCommentVNode("", true)])]), _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"bg-animation\" data-v-1cf1018e><div class=\"floating-element element-1\" data-v-1cf1018e></div><div class=\"floating-element element-2\" data-v-1cf1018e></div><div class=\"floating-element element-3\" data-v-1cf1018e></div><div class=\"floating-element element-4\" data-v-1cf1018e></div><div class=\"floating-element element-5\" data-v-1cf1018e></div></div>", 1))]), _cache[18] || (_cache[18] = _createStaticVNode("<section class=\"content-section\" data-v-1cf1018e><div class=\"container\" data-v-1cf1018e><h2 class=\"section-title\" data-v-1cf1018e>产品理念</h2><div class=\"philosophy-content\" data-v-1cf1018e><div class=\"philosophy-item\" data-v-1cf1018e><div class=\"philosophy-text\" data-v-1cf1018e><h3 data-v-1cf1018e>个性化睡眠解决方案</h3><p data-v-1cf1018e>每个人的睡眠问题都是独特的，因此我们的解决方案也必须是个性化的。通过NeuroSky脑电检测设备实时监测用户的脑电信号，我们的AI算法能够精准识别不同的睡眠阶段和问题。</p><p data-v-1cf1018e>基于这些数据，系统会智能推送最适合用户当前睡眠状态的音频内容，从引导入睡的轻音乐到促进深度睡眠的特定频率声波，每一晚都是为您量身定制的睡眠体验。</p></div><div class=\"philosophy-image\" data-v-1cf1018e><img src=\"" + _imports_0 + "\" alt=\"个性化睡眠解决方案\" data-v-1cf1018e></div></div><div class=\"philosophy-item\" data-v-1cf1018e><div class=\"philosophy-text\" data-v-1cf1018e><h3 data-v-1cf1018e>科技与自然的完美融合</h3><p data-v-1cf1018e>我们相信最有效的睡眠解决方案是科技与自然的完美结合。我们的产品采用了最先进的脑机接口技术，但最终呈现给用户的是温和、自然的睡眠体验。</p><p data-v-1cf1018e>智能枕头内置的微型扬声器通过蓝牙接收器与手机连接，播放服务器推送的定制音频。这些音频基于脑电信号分析结果，模拟自然界中促进放松和睡眠的声音环境，如轻柔的海浪、林间的风声或舒缓的雨声。</p></div><div class=\"philosophy-image\" data-v-1cf1018e><img src=\"" + _imports_1 + "\" alt=\"科技与自然的完美融合\" data-v-1cf1018e></div></div><div class=\"philosophy-item\" data-v-1cf1018e><div class=\"philosophy-text\" data-v-1cf1018e><h3 data-v-1cf1018e>全场景睡眠健康生态</h3><p data-v-1cf1018e>我们不仅仅提供单一产品，而是构建了一个完整的睡眠健康生态系统。从居家使用的智能助眠枕头，到差旅便携的脑电检测头戴设备，再到办公室午休场景的专用方案，我们覆盖了用户所有可能的睡眠场景。</p><p data-v-1cf1018e>通过Flutter框架开发的跨平台APP，用户可以随时随地查看自己的睡眠数据、接收个性化建议，并与我们的睡眠专家进行在线交流，获得专业的睡眠指导。</p><div class=\"government-certificate\" data-v-1cf1018e><div class=\"certificate-icon\" data-v-1cf1018e><i class=\"fas fa-award\" data-v-1cf1018e></i></div><div class=\"certificate-content\" data-v-1cf1018e><div class=\"certificate-badge\" data-v-1cf1018e>政府认证 · 科技专项资金支持</div><p class=\"certificate-text\" data-v-1cf1018e> 目前产品已入选<strong data-v-1cf1018e>无锡智慧健康医养设备促消费活动供应商品名录（脑机接口类）</strong>，项目研发获得<strong data-v-1cf1018e>无锡市科技发展资金</strong>支持。 </p></div></div></div><div class=\"philosophy-image\" data-v-1cf1018e><img src=\"" + _imports_2 + "\" alt=\"全场景睡眠健康生态\" data-v-1cf1018e></div></div></div></div></section>", 1)), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[8] || (_cache[8] = _createElementVNode("h2", {
        class: "section-title"
      }, "用户案例与见证", -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
        class: "section-subtitle"
      }, "真实用户的睡眠改善故事，用科技重塑睡眠体验", -1)), _createElementVNode("div", _hoisted_9, [_cache[7] || (_cache[7] = _createStaticVNode("<div class=\"case-content\" data-v-1cf1018e><div class=\"case-header\" data-v-1cf1018e><span class=\"case-badge\" data-v-1cf1018e>高龄典型用户</span><span class=\"case-duration\" data-v-1cf1018e>使用2年</span></div><h3 class=\"case-title\" data-v-1cf1018e>八旬医生减药两年实录</h3><div class=\"case-user\" data-v-1cf1018e><div class=\"user-avatar\" data-v-1cf1018e><img src=\"" + _imports_3 + "\" alt=\"刘女士\" data-v-1cf1018e></div><div class=\"user-info\" data-v-1cf1018e><h4 data-v-1cf1018e>刘女士，80岁</h4><p data-v-1cf1018e>退休医生 · 失眠十余年</p></div></div><p class=\"case-desc\" data-v-1cf1018e> &quot;北京沾边医院跑遍，中药几百副、西药20多种，最后宣武主任让我&#39;维持3小时就行&#39;。右佐匹克隆、氯硝西泮、喹硫平……剂量越吃越大，副作用越来越重，醒来还是头疼眼花。&quot; </p><div class=\"case-results\" data-v-1cf1018e><div class=\"result-item\" data-v-1cf1018e><div class=\"result-icon\" data-v-1cf1018e><i class=\"fas fa-pills\" data-v-1cf1018e></i></div><div class=\"result-details\" data-v-1cf1018e><div class=\"result-label\" data-v-1cf1018e>氯硝西泮用量</div><div class=\"result-numbers\" data-v-1cf1018e><span class=\"result-before\" data-v-1cf1018e>1片 → </span><span class=\"result-after\" data-v-1cf1018e>2/3片</span></div></div></div><div class=\"result-item\" data-v-1cf1018e><div class=\"result-icon\" data-v-1cf1018e><i class=\"fas fa-bed\" data-v-1cf1018e></i></div><div class=\"result-details\" data-v-1cf1018e><div class=\"result-label\" data-v-1cf1018e>入睡时间</div><div class=\"result-numbers\" data-v-1cf1018e><span class=\"result-before\" data-v-1cf1018e>1-2小时 → </span><span class=\"result-after\" data-v-1cf1018e>&lt;30分钟</span></div></div></div><div class=\"result-item\" data-v-1cf1018e><div class=\"result-icon\" data-v-1cf1018e><i class=\"fas fa-sync\" data-v-1cf1018e></i></div><div class=\"result-details\" data-v-1cf1018e><div class=\"result-label\" data-v-1cf1018e>醒后再睡</div><div class=\"result-numbers\" data-v-1cf1018e><span class=\"result-before\" data-v-1cf1018e>无法再次入睡</span><span class=\"result-after\" data-v-1cf1018e>可继续入睡</span></div></div></div></div><div class=\"case-highlight\" data-v-1cf1018e><i class=\"fas fa-quote-left\" data-v-1cf1018e></i><p data-v-1cf1018e>两年没再去医院，副作用大的药减量了，能睡着、能接着睡，我就挺满意！</p></div></div>", 1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("video", _hoisted_12, [_createElementVNode("source", {
        src: _unref(videoSrc),
        type: "video/mp4"
      }, null, 8, _hoisted_13), _cache[5] || (_cache[5] = _createTextVNode(" 您的浏览器不支持视频播放 "))])]), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "media-caption"
      }, "用药减量与睡眠时长变化", -1))])]), _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"stats-section\" data-v-1cf1018e><div class=\"stats-container\" data-v-1cf1018e><div class=\"stat-item\" data-v-1cf1018e><div class=\"stat-number\" data-v-1cf1018e>78<span class=\"percent\" data-v-1cf1018e>%</span></div><div class=\"stat-label\" data-v-1cf1018e>用户反馈睡眠改善</div></div><div class=\"stat-item\" data-v-1cf1018e><div class=\"stat-number\" data-v-1cf1018e>30<span class=\"percent\" data-v-1cf1018e>%</span></div><div class=\"stat-label\" data-v-1cf1018e>入睡速度提升</div></div><div class=\"stat-item\" data-v-1cf1018e><div class=\"stat-number\" data-v-1cf1018e>4.6<span class=\"small\" data-v-1cf1018e>/5.0</span></div><div class=\"stat-label\" data-v-1cf1018e>用户满意度</div></div><div class=\"stat-item\" data-v-1cf1018e><div class=\"stat-number\" data-v-1cf1018e>10<span class=\"plus\" data-v-1cf1018e>+</span></div><div class=\"stat-label\" data-v-1cf1018e>持续跟踪案例</div></div></div></div>", 1))])]), _createElementVNode("section", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[17] || (_cache[17] = _createElementVNode("h2", {
        class: "section-title"
      }, "即刻拥有", -1)), _createElementVNode("div", _hoisted_16, [_cache[15] || (_cache[15] = _createStaticVNode("<div class=\"purchase-intro\" data-v-1cf1018e><h3 data-v-1cf1018e>开启您的智能睡眠之旅</h3><p data-v-1cf1018e>现在购买我们的智能助眠系统，享受科技带来的深度睡眠体验。包含头戴式脑电检测设备、智能助眠枕头以及配套APP，为您打造全方位的睡眠解决方案。</p><div class=\"pricing-info\" data-v-1cf1018e><div class=\"price\" data-v-1cf1018e>¥2,980 <span class=\"original-price\" data-v-1cf1018e>¥3,499</span></div><div class=\"discount\" data-v-1cf1018e>老年优惠</div></div></div>", 1)), _createElementVNode("div", _hoisted_17, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "product-image"
      }, [_createElementVNode("img", {
        src: _imports_4,
        alt: "智能助眠系统"
      })], -1)), _createElementVNode("div", _hoisted_18, [_cache[12] || (_cache[12] = _createStaticVNode("<h4 data-v-1cf1018e>智能助眠系统</h4><p class=\"product-desc\" data-v-1cf1018e>包含头戴设备、智能枕头、APP使用权及一年免费服务</p><div class=\"pricing-info local-price\" data-v-1cf1018e><div class=\"price\" data-v-1cf1018e>¥2,980 <span class=\"original-price\" data-v-1cf1018e>¥3,499</span></div><div class=\"discount\" data-v-1cf1018e>老年优惠</div></div>", 3)), _createElementVNode("div", _hoisted_19, [_createElementVNode("a", {
        href: "#",
        class: "btn-primary",
        onClick: _withModifiers(goToJD, ["prevent"])
      }, "立即购买"), _cache[11] || (_cache[11] = _createElementVNode("a", {
        href: "#",
        class: "btn-secondary"
      }, "了解更多详情", -1))]), _cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "shipping-info"
      }, [_createElementVNode("p", null, "✓ 全国包邮"), _createElementVNode("p", null, "✓ 7天无理由退货"), _createElementVNode("p", null, "✓ 一年质保")], -1))])])]), _createVNode(_Transition, {
        name: "toast-fade"
      }, {
        default: _withCtx(() => [showToast.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[16] || (_cache[16] = [_createElementVNode("i", {
          class: "fas fa-spinner fa-pulse"
        }, null, -1), _createTextVNode(" 正在加急上线中，敬请期待！ ")]))) : _createCommentVNode("", true)]),
        _: 1
      })])])]), _createVNode(Footer)]);
    };
  }
};